import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useObserver } from "mobx-react-lite";
import { useAddLabelStore, usePipedriveStore } from "../..";
import { ISlimInputProps } from "./IInputProps";
import { addLabelOptionValue } from "./PipedriveLabelInput";

export default <T,>({ name, formik, className }: ISlimInputProps<T, number>) => {
    const pipedriveStore = usePipedriveStore();
    const addLabelStore = useAddLabelStore();
    const labelOptions = useObserver(() => pipedriveStore.labelOptions);

    return (
        <Select value={formik.values[name] ? String(formik.values[name]) : ""} onChange={e => e.target.value === addLabelOptionValue
            ? addLabelStore.open(labelId => formik.setFieldValue(name as string, labelId))
            : formik.setFieldValue(name as string, e.target.value === "" ? null : Number(e.target.value))} className={className} displayEmpty>
            <MenuItem value="" className={className}>----</MenuItem>
            {labelOptions.map(o => (
                <MenuItem key={o.id} value={o.id} className={className}>{o.label}</MenuItem>
            ))}
            <MenuItem value={addLabelOptionValue} className={className}>+ Add Label</MenuItem>
        </Select>
    );
}
